module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "timeline-intro",
    class: {
      'fade': _vm.selectedDecade !== 0
    },
    attrs: {
      "id": "intro"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', [_vm._v(_vm._s(_vm.introHeadline))]), _vm._v(" "), _c('div', {
    staticClass: "card-wrapper"
  }, _vm._l((_vm.introCards), function(block) {
    return _c('div', {
      key: block.id,
      staticClass: "card"
    }, [_c('div', {
      staticClass: "card-header"
    }, [_c('h2', [_vm._v(_vm._s(block.header))])]), _vm._v(" "), _c('div', {
      staticClass: "card-content"
    }, [_c('p', [_vm._v(_vm._s(block.description))])])])
  }), 0), _vm._v(" "), _c('button', {
    staticClass: "button",
    attrs: {
      "id": "start"
    },
    on: {
      "click": _vm.handleButtonClick
    }
  }, [_vm._v("See the history")])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2194e61a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2194e61a","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./timeline/js/components/Intro.vue
// module id = 45
// module chunks = 0